// NOTE: if you add any filters that rely on model ids (for ex. product.segmentId, product.recommenderId, product.campaignId, etc.)
// don't forget to change domain-migration-helper in the API to replace source ids with destination ids in segment.rules[].filters[]!
const facebookFilters = {
  count: {
    name: 'Count',
    inputType: 'range',
    conditionType: 'count',
    min: 1,
    step: 1,
    placeholder: ['e.g. 1', 'e.g. 3'],
  },
  retentionDays: {
    name: 'Retention in days',
    inputType: 'number',
    conditionType: 'retention',
    min: 1,
    max: 180,
    step: 1,
    placeholder: ['e.g. 5'],
    required: true,
  },
  value: {
    name: 'Price',
    field: 'value',
    inputType: 'range',
    conditionType: 'floatRange',
    placeholder: ['e.g. 50', 'e.g. 99'],
  },
  event: {
    name: 'Event name',
    field: 'event',
    inputType: 'string',
    conditionType: 'term',
  },
};

export default facebookFilters;
